export default "__VITE_ASSET__BM0kuJ2w__"